export default {
  CateCode: "",
  Description: "",
  AccuAccCode: null,
  AccuAccDesc: null,
  AccuDeptCode: null,
  AccuDeptDesc: null,
  AstLife: 0,
  AstLifeType: "Year",
  CostAccCode: null,
  CostAccDesc: null,
  CostDeptCode: null,
  CostDeptDesc: null,
  DepreAccCode: null,
  DepreAccDesc: null,
  DepreDeptCode: null,
  DepreDeptDesc: null,
  UserModified: localStorage.getItem("UserName"),
};
